import { Component, Input, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import { BaseService } from "../../base.service";

@Component({
  selector: "app-continue-watching",
  templateUrl: "./continue-watching.component.html",
  styleUrls: ["./continue-watching.component.css"],
})
export class ContinueWatchingComponent implements OnInit {
  @Input() content: any;
  shimmerStatus = {
    continueWatching: true,
  };
  apiParam = { slug: "home", limit: 2, offset: 0 };
  continueWatchingData = [];
  constructor(public service: BaseService, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.getContinueWatching();
  }
  upcomingShow: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    autoWidth: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 1.6,
      },
      370: {
        items: 2.6,
      },
      650: {
        items: 3,
      },
      925: {
        items: 4,
      },
      1108: {
        items: 4,
      },
      1257: {
        items: 5,
      },
      1460: {
        items: 6,
      },
    },
    nav: true,
  };
  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }
  getContinueWatching() {
    const sendData = {
      apiParam: this.apiParam,
      device_type: "web",
    };
    this.service.continueWatching(sendData).subscribe(
      (data: any) => {
        if (data.content.length > 0) {
          this.continueWatchingData = data.content;
          this.service.listStatus = true;
          this.shimmerStatus.continueWatching = false;
        } else {
          this.service.listStatus = false;
        }
      },
      (err) => {
        if (err) {
          setTimeout(() => {
            this.shimmerStatus.continueWatching = false;
            this.service.listStatus = false;
          }, 3000);
        }
      }
    );
  }

  deleteContinueWatching(data) {
    if (data === "clear_all") {
      Swal.fire({
        title: "Are you sure",
        text: "you want to remove all items?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.service.deleteContinueWatching(data).subscribe(
            (res: any) => {
              if (res) {
                this.continueWatchingData = [];
                this.service.listStatus = false;
                this.toastr.success(res.message, "Success!", {
                  closeButton: true,
                });
              }
            },
            (err) => {
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          );
        }
      });
    } else {
      Swal.fire({
        title: "Are you sure",
        text: "You want to remove this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.service.deleteContinueWatching(data).subscribe(
            (res: any) => {
              if (res) {
                this.continueWatchingData.splice(
                  this.continueWatchingData.findIndex(
                    (ele) => ele.public_id == data
                  ),
                  1
                );
                if (this.continueWatchingData.length === 0) {
                  this.service.listStatus = false;
                }
                this.toastr.success(res.message, "Success!", {
                  closeButton: true,
                });
              }
            },
            (err) => {
              this.toastr.error(err.error.message, "OOPS!", {
                closeButton: true,
              });
            }
          );
        }
      });
    }
  }
  ngOnDestroy() {
    Swal.close();
  }
}
